import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  newTowingOrderButton: { id: 'towingJobs.heading.button.new.towingOrder', defaultMessage: '+ Towing order' },
  newTowingRecordButton: { id: 'towingJobs.heading.button.new.towingRecord', defaultMessage: '+ Towing record' },
  noTowingJobs: { id: 'towingJobs.noTowingJobs', defaultMessage: 'No towing orders or records' },
})
